export const LocationRoutes = {
  PAYMENT_HANDLER: 'handle-payment',
};

export const getCurrentDomain = () => {
  return window.location.origin;
};
export const shouldRenderPaymentHandlerPage = () => {
  return window.location.pathname.startsWith(`/${LocationRoutes.PAYMENT_HANDLER}/`);
};
export const redirectUser = (redirectLink: string) => {
  window.location.href = redirectLink;
};

export const getSessionIdFromUrlParams = () => {
  const token = location.pathname.slice(1);
  return token;
};
